import React from 'react';

const PetaJalanTalentaDigitalIndonesia: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Indonesia tengah menyongsong era keemasan demografi dengan jutaan generasi muda yang tumbuh berdampingan dengan perkembangan teknologi digital. Namun, bertransisi dari sekadar bangsa konsumen teknologi menjadi produsen inovasi berdaya saing global menuntut adanya peta jalan pengembangan talenta digital yang terarah, inklusif, dan berkesinambungan.
      </p>

      <p className="mb-4">
        Platform kompetisi dan edukasi teknologi seperti <b>Indonesia Innovative Technology (IIT) Challenge</b> memainkan peranan strategis sebagai wadah inkubasi bakat sejak bangku sekolah dasar hingga perguruan tinggi, menghubungkan potensi generasi muda dengan ekosistem riset terapan dan industri nyata.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Empat Keterampilan Kunci Talenta Abad ke-21
      </h2>
      <div className="grid md:grid-cols-2 gap-4 mb-4">
        <div className="border border-gray-200 rounded-lg p-3 bg-white">
          <h3 className="font-semibold text-defaultBlue mb-1">🧠 Berpikir Komputasional</h3>
          <p className="text-sm text-gray-600">Kemampuan merumuskan masalah kompleks dan menyusun solusinya secara logis dalam alur algoritma terstruktur.</p>
        </div>
        <div className="border border-gray-200 rounded-lg p-3 bg-white">
          <h3 className="font-semibold text-defaultBlue mb-1">💡 Kreativitas & Inovasi</h3>
          <p className="text-sm text-gray-600">Keberanian mengeksplorasi ide-ide baru yang orisinal dan tidak terpaku pada solusi konvensional yang sudah ada.</p>
        </div>
        <div className="border border-gray-200 rounded-lg p-3 bg-white">
          <h3 className="font-semibold text-defaultBlue mb-1">🤝 Kolaborasi Interdisipliner</h3>
          <p className="text-sm text-gray-600">Bekerja sama melintasi batas keahlian antara programmer, desainer UI/UX, dan periset data.</p>
        </div>
        <div className="border border-gray-200 rounded-lg p-3 bg-white">
          <h3 className="font-semibold text-defaultBlue mb-1">🗣️ Komunikasi Publik (Pitching)</h3>
          <p className="text-sm text-gray-600">Keahlian menyampaikan gagasan teknis yang rumit menjadi presentasi yang memikat dan mudah dipahami masyarakat luas.</p>
        </div>
      </div>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Membangun Masa Depan Nusantara
      </h2>
      <p className="mb-4">
        Dengan pembinaan yang konsisten, ekosistem teknologi terbuka, dan apresiasi terhadap karya orisinal pelajar, Indonesia optimis mampu melahirkan generasi inovator kelas dunia yang membawa kemajuan dan kesejahteraan bagi seluruh rakyat nusantara.
      </p>
    </div>
  );
};

export default PetaJalanTalentaDigitalIndonesia;
